import { JobTimelineEvent } from '../jobs.model';
import { FC } from 'react';
import JobTimeline from './JobTimeline';
import ChevronArrowRightReactIcon from 'assets/react-icons/ChevronArrowRightReactIcon';
import { WebAppColors } from 'constants/colors';

interface JobTimelineSectionProps {
  jobTimeline: JobTimelineEvent[];
  onShowMoreClick: () => void;
  onEditNoteClick: (event: JobTimelineEvent) => void;
  onDeleteNoteClick: (event: JobTimelineEvent) => void;
  currentActionsPopoverId: number;
  setCurrentActionsPopoverId: (noteId: number) => void;
}

const JobTimelineSection: FC<JobTimelineSectionProps> = ({
  jobTimeline,
  onShowMoreClick,
  onEditNoteClick,
  onDeleteNoteClick,
  currentActionsPopoverId,
  setCurrentActionsPopoverId
}) => {
  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-sbase font-bold text-primaryText">History</div>
      <div className="rounded-md border border-borderGray">
        <JobTimeline
          jobTimeline={jobTimeline}
          limit={3}
          onEditNoteClick={onEditNoteClick}
          onDeleteNoteClick={onDeleteNoteClick}
          timelineId="job-notes-timeline"
          currentActionsPopoverId={currentActionsPopoverId}
          setCurrentActionsPopoverId={setCurrentActionsPopoverId}
        />
        <div
          className="flex cursor-pointer justify-between border-t border-secondaryBtn py-2.5 px-4"
          onClick={onShowMoreClick}>
          <div className="text-sbase font-semibold text-secondary">Show more</div>
          <ChevronArrowRightReactIcon id="job-notes-show-more-btn-icon" fill={WebAppColors.Gray_1} />
        </div>
      </div>
    </div>
  );
};

export default JobTimelineSection;
